import Header from './components/Header';
import Hero from './components/Hero';
import { AboutSection, AppSection, FeaturesSection, UpdatesSection } from './components/ContentSections1';
import { IndexSection, CommentsSection, CarouselSection } from './components/ContentSections2';
import { MediaSection, TopicsSection, FaqSection } from './components/ContentSections3';
import { ContactSection, CardsSection, RankingSection } from './components/ContentSections4';
import Footer from './components/Footer';

export default function Home() {
  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '手机观影', href: '#app' },
    { label: '精选推荐', href: '#cards' },
    { label: '常见问题', href: '#faq' },
    { label: '联系我们', href: '#contact' },
    { label: '关于我们', href: '#about' },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Header navItems={navItems} />
      <main>
        <Hero />
        <AboutSection />
        <AppSection />
        <FeaturesSection />
        <UpdatesSection />
        <IndexSection />
        <CommentsSection />
        <CarouselSection />
        <MediaSection />
        <TopicsSection />
        <FaqSection />
        <ContactSection />
        <CardsSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}